import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=f126f6e2&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=ts&"
export * from "./PageHeading.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=f126f6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f126f6e2",
  null
  
)

export default component.exports